import { normalize, schema } from 'normalizr';

// Define Schemas for use with normalizr
const Category = new schema.Entity('categories');
Category.define({ categories: [Category] });
const Categories = new schema.Object({ categories: new schema.Array(Category) });

const Designer = new schema.Entity('designer');

// const Pattern = new schema.Entity('patterns', { initialColors: [], colors: [] });
const Pattern = new schema.Entity('patterns', { designer: Designer });
const Patterns = new schema.Object({ patterns: new schema.Array(Pattern) });

export const formatDesigner = json => Object.assign({},
        normalize(json.designer, Designer),
        { result: { result: json.result, designer: [json.designer.id.toString()] } },
    );

export const formatPatterns = json => Object.assign({},
        normalize(json, Patterns),
    );

export const formatCategories = json => Object.assign({},
        normalize(json, Categories),
    );

export const formatColors = json => {
    const newColors = [];
    return (
       newColors.push = json.colors.map(color => `#${color}`)
    );
};

export const formatImageURI = json => json;



// WEBPACK FOOTER //
// ./src/helper/patterndesignSchema.js